import {
    Backdrop,
    Button,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    makeStyles,
    Typography,
} from "@material-ui/core";
import { Dialog } from "@mui/material";
import { Box } from "@mui/system";
import Config from "Config";
import jwtDecode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import iamsmartTap from "../../images/iamsmart-tap.png";
import iamSmartPhone from "../../images/icon-dark.png";
import {
    getFormId,
    getFormTitleParamList,
    getIamsmartProfile,
} from "../../redux/selector";
import { send, sendV20 } from "../../SendRequest";
import {
    getFormTitleParam,
    getIamsmartAppUrl,
    getUserAgent,
    isNotEmpty,
    isObjectNotEmpty,
} from "../../Utils";

const iamSmartBtnStyle = makeStyles((theme) => ({
    root: {
        borderRadius: 6,
        backgroundColor: theme.palette.iamSmart.main,
        color: theme.palette.common.white,
        textTransform: "none",
        "&:hover": {
            backgroundColor: theme.palette.iamSmart.main,
        },
        height: "3rem",
        fontSize: "1.11em", // 37% of height, min 12px
        "@media (max-width: 500px)": {
            height: "3.5rem",
            fontSize: "1.3em", // 37% of height, min 12px
        },
    },
}));

export default function IamsmartLoginedSigningButton({
    onSign,
    hkic,
    handleSubmit,
}) {
    const formId = useSelector(getFormId());
    const formParams = useSelector(getFormTitleParamList());
    const { t, i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    //const [openPasscodeDialog, setOpenPasscodeDialog] = useState(false);
    const [qrLinkURL, setQrLinkURL] = useState("");
    const dispatch = useDispatch();
    const handleClose = () => {
        if (isNotEmpty(requestInterval)) {
            clearInterval(requestInterval);
        }
        setOpen(false);
    };

    const [noSigning, setNoSigning] = useState(false);

    const [passcode, setPasscode] = useState("0000");
    const [businessID, setBusinessID] = useState("");
    const [ticketID, setTicketID] = useState("");
    const [authByQR, setAuthByQR] = useState(true);
    const iamSmartBtnClasses = iamSmartBtnStyle();
    const { openID, accessToken } = useSelector(getIamsmartProfile());
    const [disconnectSign, setDisconnectSign] = useState(false);
    const [failSign, setFailSign] = useState(false);
    const [timeOutSign, setTimeOutSign] = useState(false);
    const [requestInterval, setRequestInterval] = useState();
    const handleDisconnectSignClose = () => {
        setDisconnectSign(false);
    };
    const handleFailSignClose = () => {
        setFailSign(false);
    };
    const handleTimeOutSignClose = () => {
        setTimeOutSign(false);
    };

    const getFromIamsmart = () => {
        setOpen(true);
        const headers = {
            openID: openID,
            accessToken: accessToken,
            clientEntityName: "edbeform",
            HKIC: hkic,
            department: "EDB",
            serviceName: "eFormSS",
            documentName: formId,
            userAgent: navigator.userAgent,
        };
        const headersV20 = {
            accessToken,
            openID,
            source:navigator.userAgent,
            department:"EDB",
            serviceName:"eFormSS",
            documentName: `${formId} - ` +
            t(
                `form.${formId}`,
                getFormTitleParam(
                    formId,
                    formParams,
                    i18n.language
                )
            ),
            hkid:hkic,
        };
        const option = {
            url: "/iAMSmartEDB/getSigning",
            method: "POST",
            header: headers,
        };
        var optionV20 = {
            url: "/iamsmartedbv2/edbeform/signing/init",
            method: "POST",
            header: headersV20,
        };
        console.log("headersV20=======",JSON.stringify(headersV20));
        var QRLink = dispatch(sendV20("GET_SIGNING", optionV20))
            .then((response) => response.json())
            .then((result) => {
                const strData = jwtDecode(result)?.data;

                //console.log("strData=======",JSON.stringify(strData));
                //const qrLink = strData.action;
                //setQrLinkURL(qrLink);

                if(isNotEmpty(strData?.code)&& strData?.code==="D70004"){
                    setNoSigning(true);
                }
                setBusinessID(strData?.businessID);
                setPasscode(strData?.signCode);
                setTicketID(strData.ticketID);
                setAuthByQR(strData.authByQR);
                let printLogsParams = {logId: 5,msg: "GET_SIGNING_success",hkic: hkic};
                let option = {
                    url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}/printLogs`,
                    method: "POST",
                    body: JSON.stringify(printLogsParams)
                };
                dispatch(send("PRINT_LOGS", option))
                .then((response) => {
                })
            })
            .catch((error) => {
                console.log("fetch error: ", error);
                let printLogsParams = {logId: 4,msg: "GET_SIGNING_error",hkic: hkic};
                let option = {
                    url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}/printLogs`,
                    method: "POST", 
                    body: JSON.stringify(printLogsParams)
                };
                dispatch(send("PRINT_LOGS", option))
                .then((response) => {
                })
            });
    };

    const openSignLink = () => {
        window.open(qrLinkURL, "iamsmart");
    };

    const openApp = () => {
        const url = getIamsmartAppUrl(ticketID, "hash-sign");
        if (navigator.userAgent.includes("iAM Smart In-App Browser")) {
            window.location.href = url;
        } else {
            window.open(url);
        }
    };

    const channel = "IamsmartAnonSigning";
    const getSigningResult = (businessID) => {
        const headers = {
            clientEntityName: "edbeform",
            businessID: businessID,
            accessToken: accessToken,
            openID: openID,
            hashcode: "",
        };

        console.log("start interval");
        var enResponse = true;
        const interval = setInterval(() => {
            const params = {
                url:"/iamsmartedbv2/edbeform/signing/response",
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body:JSON.stringify({
                    businessID
                }),
            }
            if (enResponse) {
                enResponse = false;
                fetch(params?.url, params)
                    .then((response) => response.json())
                    .then((data) => {
                        enResponse = true;
                        const strData = jwtDecode(data)?.data?.content;
                        const strResponeData = jwtDecode(data)?.data;
                        console.log("strResponeData=======",strResponeData);
                        const responseCode = strResponeData?.code;
                        console.log("strResponeData code=======",strResponeData?.code);
                        if (isObjectNotEmpty(responseCode) && responseCode === "D70001"){
                            console.log("in D70001 logic : Signing cancelled, please try again");
                            handleClose();
                            clearInterval(interval);
                            setDisconnectSign(true);
                            return;
                        }else if (responseCode === "D70002"){
                            console.log("in D70002 logic : Signing failed, please try again");
                            handleClose();
                            clearInterval(interval);
                            setFailSign(true);
                            return;
                        }else if (responseCode === "D70003"){
                            console.log("in D70002 logic : Signing failed, please try again");
                            handleClose();
                            clearInterval(interval);
                            setTimeOutSign(true);
                            return;
                        }
                        if (isObjectNotEmpty(strData?.businessID) && isObjectNotEmpty(strData?.signature)) {
                            clearInterval(interval);
                            console.log(
                                "getAnonSigningResult response: ",
                                strData
                            );
                            setPasscode("0000");
                            handleClose();
                            onSign(
                                strData?.signature,
                                strData?.cert,
                                strData?.hashCode,
                                strData?.timestamp
                            );
                            let printLogsParams = {logId: 7,msg: "getSigningResult_success",hkic: hkic};
                            let option = {
                                url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}/printLogs`,
                                method: "POST",
                                body: JSON.stringify(printLogsParams)
                            };
                            dispatch(send("PRINT_LOGS", option))
                                .then((response) => {
                                })
                            // if (data?.response !== "noData") {
                            //     // clearInterval(interval);
                            //     // console.log(
                            //     //     "getAnonSigningResult response: ",
                            //     //     data
                            //     // );
                            //     // setPasscode("0000");
                            //     // handleClose();
                            //     // onSign(
                            //     //     data?.response?.content?.signature,
                            //     //     data?.response?.content?.cert,
                            //     //     data?.response?.content?.hashCode,
                            //     //     data?.response?.content?.timestamp
                            //     // );
                            // }
                        }
                    })
                    .catch((error) => {
                        enResponse = true;
                        console.log("fetch error: ", error);
                        let printLogsParams = {logId: 6,msg: "getSigningResult_error",hkic: hkic};
                        let option = {
                            url: `${Config.CONTENT_PATH}/${formId.toLowerCase()}/printLogs`,
                            method: "POST",
                            body: JSON.stringify(printLogsParams)
                        };
                        dispatch(send("PRINT_LOGS", option))
                            .then((response) => {
                            })
                    });
            }

        }, 2000);
        setRequestInterval(interval);
    };

    useEffect(() => {
        if (isNotEmpty(businessID)) {
            getSigningResult(businessID);
        }
    }, [businessID]);

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "90%",
        height: "90%",
        bgcolor: "white",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };
    return (
        <Box>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={disconnectSign}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t("common.iamsmart.disconnectSign")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDisconnectSignClose}>
                        {t("common.iamsmart.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={failSign}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t("common.iamsmart.failSign")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleFailSignClose}>
                        {t("common.iamsmart.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={timeOutSign}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t("common.iamsmart.failSign")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleTimeOutSignClose}>
                        {t("common.iamsmart.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
            <Button
                variant="contained"
                classes={{ root: iamSmartBtnClasses.root }}
                startIcon={
                    <img
                        className="iamSmartPhone"
                        src={iamSmartPhone}
                        alt=""
                        width="20px"
                    />
                }
                className="iamSmartButton"
                onClick={() => {
                    try {
                        handleSubmit(getFromIamsmart)();
                    } catch (error) {
                        console.log(error);
                    }
                }}
            >
                <div
                    style={
                        i18n.language === "en"
                            ? { width: "15rem", minWidth: "15rem" }
                            : {}
                    }
                >
                    {t("common.button.iamSmartSigning")}
                </div>
            </Button>
            <Box style={{ textAlign: "center" }}>
                <a
                    href={"https://www.iamsmart.gov.hk/" + i18n.language}
                    target="_blank"
                    rel="noreferrer"
                >
                    {t("common.iamsmart.moreInfo")}
                </a>
            </Box>
            {/* <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Box sx={style} p={4}>
                    {t("common.iamsmart.anonSigning.content")}
                </Box>
            </Modal>
            <Dialog
                open={openPasscodeDialog}
                onClose={() => {
                    setOpenPasscodeDialog(false);
                }}
            >
                <DialogContent>
                    <Typography>
                        {t("common.iamsmart.anonSigning.title")}
                    </Typography>
                    <Typography>
                        {t("common.iamsmart.anonSigning.service")}:{" "}
                        <b>eFormSS</b>
                    </Typography>
                    <Typography>
                        {t("common.iamsmart.anonSigning.document")}:{" "}
                        <b>{formId}</b>
                    </Typography>
                    <Typography>
                        {t("common.iamsmart.anonSigning.code")}:{" "}
                        <b>{passcode}</b>
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={openSignLink}>Sign</Button>
                </DialogActions>
            </Dialog> */}
            { businessID !=="" && <Dialog
                disableEnforceFocus
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                BackdropComponent={Backdrop}
                style={{ borderColor: "#e8e3cd" }}
            >
                <DialogTitle style={{ backgroundColor: "#e8e3cd" }}>
                    {t("common.iamsmart.anonSigning.title")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            {t("common.iamsmart.anonSigning.service")}:{" "}
                            <b>eFormSS</b>
                        </Typography>
                        <Typography>
                            {t("common.iamsmart.anonSigning.document")}:{" "}
                            <b>
                                {formId} -{" "}
                                {t(
                                    `form.${formId}`,
                                    getFormTitleParam(
                                        formId,
                                        formParams,
                                        i18n.language
                                    )
                                )}
                            </b>
                        </Typography>
                        <Typography style={{ display: "flex" }}>
                            {t("common.iamsmart.anonSigning.code")}:{" "}
                            {passcode != "0000" && (
                                <Typography
                                    style={{
                                        color: "#2B7366",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {passcode}
                                </Typography>
                            )}
                        </Typography>
                    </DialogContentText>
                    <DialogContentText>
                        {t("common.iamsmart.signing.instruction")}
                    </DialogContentText>
                    {!noSigning && <DialogContentText>
                    {getUserAgent() === "" ?
                        <ol>
                            {t("common.iamsmart.signing.step", {
                                returnObjects: true,
                            }).map((criteria, index) => {
                                if (index === 0) {
                                    return (
                                        <>
                                        <Typography
                                            style={{
                                                color: "#2B7366",
                                            }}
                                        >
                                            <li key={index}>
                                                    {criteria}
                                            </li>
                                        </Typography>
                                            {authByQR && (
                                                <img
                                                    src={iamsmartTap}
                                                    alt={"i am smart icon"}
                                                    style={{
                                                        width: "100px",
                                                    }}
                                                />
                                            )}
                                        </>
                                    );
                                }
                                return <li key={index}>{criteria}</li>;
                            })}
                        </ol>
                        :
                        <ol>
                            {t("common.iamsmart.sameSigning.step", {
                                returnObjects: true,
                            }).map((criteria, index) => {
                                if (index === 0) {
                                    return (
                                        <>
                                            <li key={index}>
                                                <Typography
                                                    style={{
                                                        color: "#2B7366",
                                                    }}
                                                >
                                                    {criteria}
                                                </Typography>
                                            </li>
                                            {authByQR && (
                                                <img
                                                    src={iamsmartTap}
                                                    alt={"i am smart icon"}
                                                    style={{
                                                        width: "100px",
                                                    }}
                                                />
                                            )}
                                        </>
                                    );
                                }
                                return <li key={index}>{criteria}</li>;
                            })}
                        </ol>
                    }
                    </DialogContentText>
                    }
                    <DialogActions>
                    {!noSigning && !authByQR && (
                            <Button
                                variant="contained"
                                classes={{ root: iamSmartBtnClasses.root }}
                                startIcon={
                                    <img
                                        className="iamSmartPhone"
                                        src={iamSmartPhone}
                                        alt=""
                                        width="20px"
                                    />
                                }
                                className="iamSmartButton"
                                onClick={openApp}
                                //onClick={openSignLink}
                            >
                                <div>{t("common.iamsmart.openIamSmartSign")}</div>
                            </Button>
                    )}
                    {noSigning && (
                        <Typography >
                            {
                                <span
                                        className="tooltips"
                                        dangerouslySetInnerHTML={{
                                            __html: t("common.iamsmart.noSigning"),
                                        }}
                                    >
                                </span>
                            }
                        </Typography>
                    )}
                    </DialogActions>
                </DialogContent>
                </Dialog>
            }
        </Box>
    );
}
